import React from "react";
import styled from "@emotion/styled";

const CardContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  padding: "1.5rem 2.0rem",
  cursor: "pointer",
});

const NameWrapper = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "0.4rem",

  ".time": {
    color: theme.color.light_gray,
    fontSize: "1.2rem",
    fontWeight: theme.fontWeight.medium,
  },
}));

const NameBox = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "0.5rem",
  color: theme.color.black,
  fontWeight: theme.fontWeight.bold,
  lineHeight: "normal",
}));

const MintBall = styled.div(({ theme }) => ({
  width: "1rem",
  height: "1rem",
  borderRadius: "50%",
  backgroundColor: theme.color.mint,
}));

const Content = styled.span(({ theme }) => ({
  fontSize: "1.6rem",
  color: theme.color.black,
}));

const Item = styled.span(({ theme }) => ({
  fontSize: "1.2rem",
  color: theme.color.light_gray,
}));

type Props = {
  name: string;
  content: string;
  time: string;
  item: string;
  read: boolean;
  onClick?: () => void;
};
const InquiryCard = ({ name, content, time, item, read, onClick }: Props) => {
  return (
    <CardContainer onClick={onClick}>
      <NameWrapper>
        <NameBox>
          <span>{name}</span>
          {read && <MintBall />}
        </NameBox>

        <span className="time">{time}</span>
      </NameWrapper>

      <Content className="ellipsis-1">{content}</Content>

      <Item>{item}</Item>
    </CardContainer>
  );
};

export default InquiryCard;
